import React from 'react';
import { ContentContainer } from './content-container';

interface PageHeroProps {
  title: React.ReactNode;
  /** Text-only description - will be wrapped in a p tag */
  description?: string;
  /** React component description - will be wrapped in a div */
  descriptionComponent?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  variant?: 'default' | 'gradient' | 'subtle' | 'tablab';
  noBorder?: boolean;
  action?: React.ReactNode;
}

export function PageHero({ 
  title, 
  description,
  descriptionComponent,
  children, 
  className = '',
  variant = 'default',
  noBorder = false,
  action
}: PageHeroProps) {
  // Define background styles based on variant
  const getHeaderStyles = () => {
    switch (variant) {
      case 'gradient':
        return 'bg-supernova-galaxy text-foreground';
      case 'subtle':
        return `bg-muted ${noBorder ? '' : 'border-b border-border/40'}`;
      case 'tablab':
        return `bg-background ${noBorder ? '' : 'border-b border-border/40'}`;
      default:
        return 'bg-background';
    }
  };

  const descriptionClasses = `text-lg ${variant === 'gradient' ? 'text-foreground/80' : 'text-muted-foreground'} mb-3 text-left`;

  return (
    <div className={`w-full ${className}`}>
      <div className={`py-4 ${getHeaderStyles()}`}>
        <ContentContainer>
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
            <div>
              <h1 className="text-3xl font-bold mb-2 text-left text-foreground">{title}</h1>
              {description && (
                <p className={descriptionClasses}>
                  {description}
                </p>
              )}
              {descriptionComponent && (
                <div className={descriptionClasses}>
                  {descriptionComponent}
                </div>
              )}
            </div>
            {action && (
              <div className="flex justify-start sm:justify-end sm:ml-4">
                {action}
              </div>
            )}
          </div>
        </ContentContainer>
      </div>
      
      {children && (
        <div className="w-full">
          {children}
        </div>
      )}
    </div>
  );
} 